import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import type { PsfShareChannel } from 'src/app/pages/psf/share/shared/types';
import { createNewShare } from 'src/app/shared/api/share';

export function useCreateNewShare() {
	const utilityContext = useUtilityContext();
	const {
		data: {
			petition: { id },
		},
	} = usePsfSharePageData();

	return useCallback(
		async (channel: PsfShareChannel) => {
			// only creating new share if user checked the "public" option when signing
			if (!utilityContext.cookies.get(`app_meta_public_signature_${id}`)) {
				return null;
			}

			return createNewShare(utilityContext, id, channel, { silent: true });
		},
		[id, utilityContext],
	);
}
